import { useState } from "react";
import { Button, Modal } from "antd";
import * as S from "./styles";

export const CreateStoreModal = ({ open, onCancel, onSubmit }) => {
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const formData = new FormData(e.currentTarget);

      const title = formData.get("title")?.toString();
      const cnpj = formData.get("cnpj")?.toString();
      const address = formData.get("address")?.toString();
      const neighborhood = formData.get("neighborhood")?.toString();
      const city = formData.get("city")?.toString();
      const state = formData.get("state")?.toString();
      const postal_code = formData.get("postal_code")?.toString();
      const area_code = formData.get("area_code")?.toString();
      const phone_number = formData.get("phone_number")?.toString();
      const contact_name = formData.get("contact_name")?.toString();
      const contact_email = formData.get("contact_email")?.toString();
      const contact_phone = formData.get("contact_phone")?.toString();
      const contact_group = formData.get("contact_group")?.toString();
      const contact_consultant = formData.get("contact_consultant")?.toString();

      await onSubmit({
        title,
        cnpj,
        address,
        neighborhood,
        city,
        state,
        postal_code,
        area_code,
        phone_number,
        contact_name,
        contact_email,
        contact_phone,
        contact_group,
        contact_consultant,
      });
    } catch (error) {
      console.error("failed to create store", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Registrar Nova Concessionária"
      open={open}
      onCancel={handleCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
    >
      <S.Container onSubmit={handleSubmit}>
        <input type="text" name="title" placeholder="Concessionária" required />

        <input type="text" name="cnpj" placeholder="CNPJ" required />

        <input type="text" name="address" placeholder="Endereço" required />

        <input type="text" name="neighborhood" placeholder="Bairro" required />

        <input type="text" name="city" placeholder="Cidade" required />

        <input
          type="text"
          maxLength={2}
          name="state"
          placeholder="Estado"
          required
        />

        <input type="text" name="postal_code" placeholder="CEP" required />

        <input
          type="text"
          maxLength={3}
          name="area_code"
          placeholder="DDD"
          required
        />

        <input
          type="text"
          name="phone_number"
          placeholder="Telefone"
          required
        />

        <div
          className="ant-modal-title"
          style={{
            margin: "8px 0",
          }}
        >
          Contato Marketing
        </div>

        <input type="text" name="contact_name" placeholder="Nome" required />

        <input
          type="email"
          name="contact_email"
          placeholder="E-mail"
          required
        />

        <input
          type="text"
          name="contact_phone"
          placeholder="Telefone"
          required
        />

        <input type="text" name="contact_group" placeholder="Grupo" required />

        <input
          type="text"
          name="contact_consultant"
          placeholder="Consultor Comercial YAMAHA"
          required
        />

        <Button
          type="primary"
          htmlType="submit"
          id="app-button"
          disabled={loading}
        >
          {loading ? "Carregando..." : "Registrar"}
        </Button>
      </S.Container>
    </Modal>
  );
};
